import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Phone({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
      fill="none"
    >
      <Path
        d="M3.33337 8C3.33337 14.9956 9.00443 20.6667 16 20.6667C17.3833 20.6667 18.7148 20.4449 19.9609 20.0351V15H16L13.9029 17.0968C10.3387 16.2785 7.55356 13.4193 6.84314 9.81524L8.66671 8V4H3.97792C3.90488 4.21961 3.8377 4.4419 3.77655 4.66667C3.4876 5.72876 3.33337 6.84637 3.33337 8Z"
        stroke={iconColor}
        strokeWidth={1.33333}
        strokeLinejoin="round"
      />
      <Path
        d="M13.4281 6.05402C15.5708 6.36062 17.2995 7.93874 17.8304 9.99933H16.4349C15.957 8.64961 14.777 7.63311 13.3334 7.39093V6.71417L13.4281 6.05402Z"
        fill={iconColor}
      />
      <Path
        d="M12.6666 2.69C17.1783 3.00841 20.8046 6.53345 21.2803 10.9999"
        stroke={iconColor}
        strokeWidth={1.33333}
        strokeLinejoin="round"
      />
      <Path
        d="M13.3334 6.71375C15.2329 6.98545 16.7634 8.40108 17.2047 10.2404"
        stroke={iconColor}
        strokeWidth={1.33333}
        strokeLinejoin="round"
      />
    </Svg>
  );
}
